// A handful of people published under a different slug than staff.ts uses
// for the same person — webadmin and staff.ts's own ingestion generate
// slugs differently (name-word order, or a disambiguating suffix staff.ts
// adds that webadmin doesn't know about) often enough that this needs to be
// a real, maintained list rather than something solved once.
//
// Every pair here was verified by hand, not guessed: full name, designation
// AND department all agree between the two systems — the same discipline
// deptBoards.ts already uses for cross-system name matching ("initials must
// be identical, only additional name words may differ"), just with two
// independent identity fields (designation + department) checked as well,
// since a first+last name alone is not always unique (see pooja-k-n below,
// where two different staff.ts people share the exact name — department is
// what separates them).
//
// Reconciled 2026-09-17:
//   poornima-b   (published, ISE) = b-poornima     (staff.ts, IS)  — Professor
//   shwetha-s-2  (published, IOT) = shwetha-s-iss   (staff.ts, ISS) — Asst Professor
//   shwetha-s    (published, ECE) = shwetha-s-ec    (staff.ts, EC)  — Asst Professor
//   pooja-k-n    (published, MCA) = pooja-k-n-em1386 (staff.ts, MCA) — Asst Professor
//     NOT pooja-k-n-em1459 (staff.ts, MAT) — same name+designation, wrong
//     department; staff.ts's own -em#### suffix exists specifically to
//     disambiguate this exact name collision, and department is what
//     resolves which of the two this published record is.
//
// Keyed by published slug -> staff.ts slug, since every consumer starts
// from a published record and needs to know which staff.ts identity it
// belongs to.
export const PUBLISHED_SLUG_ALIASES: Record<string, string> = {
  "poornima-b": "b-poornima",
  "shwetha-s-2": "shwetha-s-iss",
  "shwetha-s": "shwetha-s-ec",
  "pooja-k-n": "pooja-k-n-em1386",
};

/** A published record's slug, normalized to its staff.ts identity. */
export function normalizePublishedSlug(slug: string): string {
  return PUBLISHED_SLUG_ALIASES[slug] ?? slug;
}
